var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BCard, BTable } from 'bootstrap-vue';
let ShippingZones = class ShippingZones extends Vue {
    constructor() {
        super(...arguments);
        this.fields = [
            { key: 'zone', label: 'Zone', thStyle: 'width:225px;' },
            { key: 'cost', label: 'Cost', formatter: val => `£${val}`, thStyle: 'width: 100px;' }
        ];
    }
    get items() {
        return Object.keys(this.zonePrices).map(zone => ({
            zone,
            cost: this.zonePrices[zone]
        }));
    }
};
__decorate([
    Prop(Object)
], ShippingZones.prototype, "zonePrices", void 0);
ShippingZones = __decorate([
    Component({
        components: {
            BCard, BTable
        }
    })
], ShippingZones);
export default ShippingZones;
